import { render, staticRenderFns } from "./image-viewer-modal.vue?vue&type=template&id=e0054270&scoped=true"
import script from "./image-viewer-modal.ts?vue&type=script&lang=ts&external"
export * from "./image-viewer-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./image-viewer-modal.less?vue&type=style&index=0&id=e0054270&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0054270",
  null
  
)

export default component.exports